export default {
  meta: {
    title: '绩效报表',
    parentPath: ['/dfrc/storemap'],
  },
};
